import { render, staticRenderFns } from "./ResultLow.vue?vue&type=template&id=56ddda46&scoped=true&"
import script from "./ResultLow.vue?vue&type=script&lang=js&"
export * from "./ResultLow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ddda46",
  null
  
)

export default component.exports